export default "__VITE_ASSET__Bj6mUHeh__"